import create from 'zustand';
import { persist } from 'zustand/middleware';

type BooleanStore = {
  value: boolean;
};

export const createBooleanStore = (persistKey?: string, defaultValue: boolean = false) => {
  const initialState: BooleanStore = {
    value: defaultValue,
  };

  const useStore = persistKey
    ? create(persist<BooleanStore>(() => initialState, { name: persistKey }))
    : create<BooleanStore>(() => initialState);

  const setValue = (value: boolean) => useStore.setState({ value });
  const toggle = () => useStore.setState((state) => ({ value: !state.value }));
  const reset = () => useStore.setState(initialState);

  return { useStore, setValue, toggle, reset };
};

export type BooleanStoreType = ReturnType<typeof createBooleanStore>;
